import { type FlexsaveType, FlexsaveTypes } from "@doitintl/cmp-models";

export function getFlexsaveTypeFullName(type: FlexsaveType) {
  return type === FlexsaveTypes.AWS ? "amazon-web-services" : "google-cloud";
}
